export default function scrollTop () {
    $('html, body').stop().animate({
        'scrollTop': 0,
    }, 900, 'swing', function () {
        $(window).trigger('scroll');
    });
}